export default "__VITE_ASSET__HqwrckJq__"